module.exports = __webpack_public_path__ + "media/images/flags/YE-f5cb6ff24d390752d0c865c5ecf2d473.svg";